import { render, staticRenderFns } from "./leftBanner.vue?vue&type=template&id=c1dbb3f4&scoped=true&"
import script from "./leftBanner.vue?vue&type=script&lang=js&"
export * from "./leftBanner.vue?vue&type=script&lang=js&"
import style0 from "./leftBanner.vue?vue&type=style&index=0&id=c1dbb3f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1dbb3f4",
  null
  
)

export default component.exports